import {match} from 'ts-pattern';

import {VehicleFinancingType} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

export function getFinancingTypeLabel(type: VehicleFinancingType) {
  return match(type)
    .with('STANDARD', () => i18n.t('page.vehicle.financingAndLeasing.standard'))
    .with('BALLOON', () => i18n.t('page.vehicle.financingAndLeasing.balloon'))
    .exhaustive();
}
